// extracted by mini-css-extract-plugin
module.exports = {"searchSuggestions":"searchSuggestions_searchSuggestions__3ybsf","title":"searchSuggestions_title__7vX1b","suggestionsRow":"searchSuggestions_suggestionsRow__e91x_"};